import * as React from 'react';
import { useIntl } from 'react-intl';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { Plan } from '../../services/PlansService';
import { PlanItem } from '../plans/PlanItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import { AppContext } from '../../contexts/AppContext';

interface TrainingRunStep2SelectPlanProps {
  plans: Plan[];
  isLoading: boolean;
  onSelectPlan: (plan: Plan) => void;
}

const TrainingRunStep2SelectPlan: React.FC<TrainingRunStep2SelectPlanProps> = ({
  plans,
  isLoading,
  onSelectPlan
}) => {
  const intl = useIntl();
  const { plansService, userService } = React.useContext(AppContext);

  if (isLoading) {
    return (
      <Box height="100vh" width="100%" display="flex" alignItems="center" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  if (!plans.length) {
    return (
      <Box height="100vh" width="100%" display="flex" alignItems="center" justifyContent="center">
        <Typography variant="body1" color="text.secondary">
          {intl.formatMessage({ id: 'trainingRun.noPlansFound' })}
        </Typography>
      </Box>
    );
  }

  return (
    <Box marginTop={4}>
      {userService.user?.id && (
        <InfiniteScroll
          dataLength={plans.length}
          next={() => {
            plansService.loadPlans(userService.user!.id!);
          }}
          hasMore={plansService.hasMorePlans}
          scrollThreshold={1}
          loader={<Box height={100} width="100%" display="flex" alignItems="center" justifyContent="center"><CircularProgress /></Box>}
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            marginTop: "-32px",
            width: "calc(100% + 32px)",
            marginLeft: "-32px",
            padding: "32px",
          }}
        >
          {plans.map((plan) => (
            <PlanItem
              key={plan.id}
              plan={plan}
              onClick={() => onSelectPlan(plan)}
            />
          ))}
        </InfiniteScroll>
      )}
    </Box>
  );
};

export default TrainingRunStep2SelectPlan;
